const lengthFactor = 16
const flexMapping = {
  left: 'flex-start',
  center: 'center',
  start: 'flex-end',
}

export default {
  data() {
    return {
      dom: {
        containerHeight: 0,
        containerWidth: 0,
        // containerHeight: 0,
        // containerWidth: 0,
        maxWidths: [],
        totalWidth: 0,
        scrollbarSize: {},
      },
    }
  },
  methods: {
    cellSizeAndPositionGetter(item, index) {
      let width = this.dom.totalWidth
      let height = 48
      return {
        width: width,
        height: height,
        x: 0,
        y: parseInt(index) * height,
      }
    },
    resizeListener() {
      let virtualContainer = this.$refs['virtualContainer']
      if (virtualContainer) {
        this.$set(this.dom, 'containerHeight', virtualContainer.offsetHeight)
        this.$set(this.dom, 'containerWidth', virtualContainer.offsetWidth)
      }
    },
    getMaxWidth(key, header) {
      let width = this.dom.maxWidths[key] || 100
      let alignment = header.align || 'center'
      let result = `width: ${width}px; min-width: ${width}px; max-width: ${width}px; justify-content: ${flexMapping[alignment]}; text-align: ${alignment};`

      return result
    },
    accessItemValue(header, item) {
      let val
      if (typeof header.accessor === 'function') {
        val = header.accessor(item)
      } else if (header.value != null || header.value != undefined) {
        val = item[header.value]
      } else {
        return null
      }
      return (typeof header.format === 'function') ? header.format(val) : val
    },
    updateMaxWidths(headers, items) {
      const getWidth = (header, datum) => {
        let headerWidth = header.text.length * lengthFactor
        let val = datum && this.accessItemValue(header, datum)
        if (!val) {
          return headerWidth
        }
        let length = String(val).length
        let cellWidth = length * lengthFactor
        return headerWidth > cellWidth ? headerWidth : cellWidth
      }

      let maxWidths = {}
      headers.forEach(header => {
        const initializedWidth = getWidth(header, null)
        maxWidths[header.text] = initializedWidth
      })

      items.forEach(item => {
        headers.forEach(header => {
          let index = header.text
          let thisWidth

          if (header.width) {
            thisWidth = header.width
          } else {
            thisWidth = getWidth(
              header,
              item.data
            )
          }
          if (!maxWidths[index] || (maxWidths[index] < thisWidth)) {
            maxWidths[index] = thisWidth
          }
        })
      })
      this.dom.maxWidths = maxWidths
      this.dom.totalWidth = Object.values(maxWidths).reduce(
        (accumulator, currentValue) => {
          return accumulator + currentValue
        },
        0
      )
    },
  },
}